export default __webpack_public_path__ + "static/steel-circle-f1bf5e48cdb70648eb26718db772c8e7.png";